import React, { useCallback, useMemo, useState } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import Checklist from 'routes/Products/components/Checklist';

export default ({ title = 'This Week’s Action Items', checklist, userAnalytics }) => {
  if (!checklist) return null;
  const _userAnalytics = userAnalytics || (() => {});
  return (
    <Card>
      <CardBody>
        <Checklist
          userAnalytics={_userAnalytics}
          handleComplete={() => {}}
          overrideTitle={title}
          HeaderWrapperTag={CardHeader}
          {...checklist}
        />
      </CardBody>
    </Card>
  );
};
